import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import * as Rx from "rxjs"
import { retry } from "rxjs/operators"
import { request } from "../utils/http"
import type { RecordType } from "./types"

export const getGenericRecordById = (
    headers: Record<string, any>,
    recordType: RecordType,
    recordId: string
): Rx.Observable<Maybe<Record<string, any>>> =>
    Rx.defer(() =>
        request({
            method: "GET",
            path: generateUrlForRecord(recordType, recordId),
            headers: headers,
        })
    ).pipe(retry(2))

export const generateUrlForRecord = (recordType: string, recordId: string): string =>
    `/data/${recordType.replace(/_/g, "-")}/${recordId}`
